module.exports = __webpack_public_path__ + "img/167-Slate Grey Finesse.jpg";